// // sub.jsファイルを読み込む
// import {hello} from "./sub";
// // sub.jsに定義されたJavaScriptを実行する
// hello();

// Javascript
// - node_modules


import Common from './Common';
import FrontPage from './FrontPage';
import AboutPage from './AboutPage';
import ContactPage from './ContactPage';
import CookieConsent from './CookieConsent';

// Sass/css
// - from node_modules
import "animate.css";
// import 'normalize.css';
// - from original theme
import "../sass/style.scss";

console.log('start shibuyabai!! ')

const common = Common.getInstance();
const frontPage = FrontPage.getInstance();
const aboutPage = AboutPage.getInstance();
const contactPage = ContactPage.getInstance();

const cookieConsent = CookieConsent.getInstance();

